import { AutogenLayoutEdiPartnerQualifiers } from "./autogen/AutogenLayoutEdiPartnerQualifiers";
import { LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { EdiPartnerQualifiersHelper } from "./EdiPartnerQualifiersBase";

export class EdiPartnerQualifiers extends AutogenLayoutEdiPartnerQualifiers {
    private _partnerId: string;
    private _version: string;

    setPartnerValues(partnerId: string, version: string) {
        this._partnerId = partnerId;
        this._version = version;
    }

    setColumnsForTender() {
        const columnsToRemove = ["columnHeaderFault", "columnIncludePickups", "columnIncludeDeliveries"];
        EdiPartnerQualifiersHelper.setColumnsForTender(this.tablePartnerQualifiers, columnsToRemove);
    }

    setEnabledButtonEnabledProperties(isEnabled: boolean) {
        EdiPartnerQualifiersHelper.setEnabledButtonEnabledProperties(this.buttonDisableAll, this.buttonEnableAll, isEnabled);
    }

    async disableButtonOnClick() {
        await EdiPartnerQualifiersHelper.setRecordsOnClick(
            this.tablePartnerQualifiers,
            this.mainDataSource,
            false,
            "Are you sure you want to disable all qualifier codes?",
            this.buttonDisableAll
        );
    }

    async enableButtonOnClick() {
        await EdiPartnerQualifiersHelper.setRecordsOnClick(
            this.tablePartnerQualifiers,
            this.mainDataSource,
            true,
            "Are you sure you want to enable all qualifier codes?",
            this.buttonEnableAll
        );
    }

    returnFormattedRows() {
        return EdiPartnerQualifiersHelper.returnFormattedRows(this.tablePartnerQualifiers);
    }

    beforeStandardCodeLookup(event: LookupModelSearchEvent) {
        EdiPartnerQualifiersHelper.setupLookupFilter(event, this.partnerId, this.version, false);
    }

    standardCodeOnLookupModelSearch(event: LookupModelSelectionEvent) {
        EdiPartnerQualifiersHelper.handleLookupSelection(event, this.partnerId, this.version);
    }

    get partnerId(): string {
        return this._partnerId;
    }

    set partnerId(value: string) {  
        this._partnerId = value;
    }

    get version(): string {
        return this._version;
    }

    set version(value: string) {
        this._version = value;
    }
}